import { matchPath } from "react-router-dom";
import routes from "../routes";

const SEGMENT_SEPARATOR = /\s+[>/]\s+/;

export function lastTitleSegment(title) {
  const segments = String(title || "")
    .split(SEGMENT_SEPARATOR)
    .map(segment => segment.trim())
    .filter(segment => segment && !segment.startsWith(":"));
  return segments.length ? segments[segments.length - 1] : "";
}

export function crumbLabel(t, crumb) {
  if (crumb.routeKey) {
    return lastTitleSegment(t(`shell.route.${crumb.routeKey}`));
  }
  return crumb.labelKey ? t(crumb.labelKey) : "";
}

export function fillPath(template, params = {}) {
  if (!template) return "";
  return template.replace(/:([A-Za-z]+)/g, (_, key) =>
    params[key] == null ? "" : String(params[key])
  );
}

function routeScore(path) {
  const params = (path.match(/:[A-Za-z]+/g) || []).length;
  const staticLength = path.replace(/:[A-Za-z]+/g, "").length;
  return params * 10000 - staticLength;
}

export function findRoute(pathname) {
  const matches = routes
    .map(route => {
      const match = matchPath(pathname, { path: route.path, exact: true });
      if (!match || !match.isExact) return null;
      return { route, params: match.params || {} };
    })
    .filter(Boolean);

  if (!matches.length) return null;

  matches.sort((a, b) => routeScore(a.route.path) - routeScore(b.route.path));
  return matches[0];
}
